import { AxiosResponse } from 'axios';
import config from '../../../configs/config';
export interface IServiceValidationError {
	Id: number;
	Field: string;
	Message: string;
}
export interface IServiceValidationErrorData {
	Code: number;
	Service?: keyof typeof ServiceMapForErrors;
	ValidationErrors: IServiceValidationError[];
}

export interface IServiceRegularErrorData {
	Code: number;
	ErrorCode?: number;
	Service?: keyof typeof ServiceMapForErrors;
	Error: string;
	ErrorMessage?: string;
}

/* tslint:disable */
// order matters here, example auxiliary service has to be beneath campaigns service since it has /campaigns in the url and has to be last checked
export const ServiceMapForErrors = {
	CampaignsService: config.campaign_management_service.base_url,
	AuxiliaryService: config.auxiliary_service.base_url,
	EntitiesService: config.entities_service.base_url,
	UsersManagementService: config.account_service.base_url,
	MembersService: config.members_management_service.base_url,
	SegmentationService: config.segments_service.base_url,
	AutomationsService: config.automationsService.base_url,
};
/* tslint:enable */

export const ApiValidationErrorMap: IApiErrorMap = {
	AuxiliaryService: {
		// just for init
		RegularErrors: {},
		ValidationErrors: {},
	},
	CampaignsService: {
		RegularErrors: {},
		ValidationErrors: {},
	},
	EntitiesService: {
		// just for init
		RegularErrors: {},
		ValidationErrors: {},
	},
	UsersManagementService: {
		// just for init
		RegularErrors: {},
		ValidationErrors: {},
	},
	MembersService: {
		// just for init
		RegularErrors: {},
		ValidationErrors: {},
	},
	SegmentationService: {
		// just for init
		RegularErrors: {},
		ValidationErrors: {},
	},
	AutomationsService: {
		// just for init
		RegularErrors: {},
		ValidationErrors: {},
	},
};

export type IApiErrorMap = {
	[K in keyof typeof ServiceMapForErrors]: ISingleServiceApiErrorMap;
};

export interface ISingleServiceApiErrorMap {
	ValidationErrors: IIdBasedErrorMap;
	RegularErrors: IIdBasedErrorMap;
}

export interface IIdBasedErrorMap {
	[x: number]: string | any;
}

export const registerToCentralErrorMap = (serviceName: keyof typeof ServiceMapForErrors, map: ISingleServiceApiErrorMap) => {
	ApiValidationErrorMap[serviceName] = map;
	return map;
};

export const resolveApiValidationErrorMessage = (
	axiosResponse: AxiosResponse,
	serviceValidationData: IServiceValidationErrorData
): string => {
	const validationErrors = serviceValidationData.ValidationErrors;
	const errorMapName = axiosResponse.config.url && getErrorMapName(axiosResponse.config.url);
	// console.log(axiosResponse.config.url, errorMapName, ApiValidationErrorMap[errorMapName]);
	// first check if error exists on the local error map, if we need to override the api returned message
	if (
		validationErrors &&
		validationErrors.length &&
		errorMapName &&
		ApiValidationErrorMap[errorMapName].ValidationErrors[validationErrors[0].Id]
	) {
		return ApiValidationErrorMap[errorMapName].ValidationErrors[validationErrors[0].Id];
	}

	// id here is temporary just so that messages can be identified by testers
	return (validationErrors && validationErrors.length && validationErrors[0].Message) || 'Unknown error occured!';
};

export const resolveApiRegularErrorMessage = (
	axiosResponse: AxiosResponse,
	serviceValidationData: IServiceRegularErrorData,
	type?: string
): string => {
	const errorMapName = axiosResponse.config.url && getErrorMapName(axiosResponse.config.url);

	const code = serviceValidationData.ErrorCode ? serviceValidationData.ErrorCode : serviceValidationData.Code;
	const message = serviceValidationData.ErrorMessage ? serviceValidationData.ErrorMessage : serviceValidationData.Error;
	// first check if error exists on the local error map, if we need to override the api returned message
	if (code && message && errorMapName && ApiValidationErrorMap[errorMapName].RegularErrors[code]) {
		if (type) {
			return ApiValidationErrorMap[errorMapName].RegularErrors[code](type);
		}
		return ApiValidationErrorMap[errorMapName].RegularErrors[code];
	}

	// id here is temporary just so that messages can be identified by testers
	return code && message ? message : 'Unknown error occured!';
};

const getErrorMapName = (serviceUrl: string): keyof typeof ServiceMapForErrors | null => {
	let serviceName: keyof typeof ServiceMapForErrors | null = null;

	Object.keys(ServiceMapForErrors).forEach((key: keyof typeof ServiceMapForErrors) => {
		if (serviceUrl.includes(ServiceMapForErrors[key])) {
			if (serviceName) {
				// a way not to distinguish between main service and subservice /campaigns vs /campaigns/auxiliary, longer string indicates a subservice
				serviceName = ServiceMapForErrors[serviceName].length > ServiceMapForErrors[key].length ? serviceName : key;
			} else {
				serviceName = key;
			}
		}
	});

	return serviceName;
};
